import { defaultPlantSlotRequired, isPlantPacketItem } from "./plantPacket.js";

const DONE = new Set(["received", "verified"]);

export type PlantPacketCompletenessItem = {
  item_key: string;
  label: string;
  status: string;
  packet_layer?: string | null;
  required?: boolean | null;
  evidence_url?: string | null;
};

export function plantSlotIsRequired(item: PlantPacketCompletenessItem): boolean {
  if (typeof item.required === "boolean") return item.required;
  return defaultPlantSlotRequired(item.item_key);
}

/** Required plant slots must be received/verified (upload or stamped URL). Waive is not enough. */
export function plantSlotIsSatisfied(
  item: PlantPacketCompletenessItem,
  attachmentCount = 0
): boolean {
  if (DONE.has(item.status)) return true;
  if (attachmentCount > 0) return true;
  if (typeof item.evidence_url === "string" && item.evidence_url.trim()) return true;
  if (!plantSlotIsRequired(item) && (item.status === "waived" || item.status === "missing")) {
    return true;
  }
  return false;
}

export function missingRequiredPlantSlots(
  items: readonly PlantPacketCompletenessItem[],
  attachmentCounts: ReadonlyMap<string, number> = new Map()
): PlantPacketCompletenessItem[] {
  return items.filter((item) => {
    if (!isPlantPacketItem(item)) return false;
    if (!plantSlotIsRequired(item)) return false;
    const n = attachmentCounts.get(item.item_key) ?? 0;
    return !plantSlotIsSatisfied(item, n);
  });
}

export function plantPacketReadyToSubmit(
  items: readonly PlantPacketCompletenessItem[],
  attachmentCounts?: ReadonlyMap<string, number>
): boolean {
  return missingRequiredPlantSlots(items, attachmentCounts).length === 0;
}
